import { Box, Button, Switch, Text, Toast } from '@bonanza-social/moonlight';
import { useDispatch } from '@bonanza-social/toolkit/state';
import { memo, useCallback, useState } from 'react';
import { updateMFA } from '../../state';
import useMFAEnabled from '../../hooks/useMFAEnabled';
import { useTranslation } from '@bonanza-social/i18n';

function AccountMFA() {
  const { t } = useTranslation('account');
  const { mfaEnabled, isUpdating } = useMFAEnabled();
  const [localEnabled, setLocalEnabled] = useState(mfaEnabled ?? false);
  const dispatch = useDispatch();

  const onSave = useCallback(async () => {
    // Only send request if the local and server state are different
    if (localEnabled !== mfaEnabled) {
      const result = await dispatch(updateMFA(localEnabled));

      if (updateMFA.fulfilled.match(result)) {
        Toast.show({
          type: 'success',
          title: t('mfaModalTitle'),
          text: t(localEnabled ? 'mfaEnabledMessage' : 'mfaDisabledMessage'),
        });
      } else if (updateMFA.rejected.match(result)) {
        Toast.show({
          type: 'error',
          title: t('notificationErrorTitle'),
          text: t('notificationErrorDescription'),
        });
      }
    } else {
      Toast.show({
        type: 'success',
        title: t('mfaModalTitle'),
        text: t(localEnabled ? 'mfaEnabledMessage' : 'mfaDisabledMessage'),
      });
    }
  }, [dispatch, localEnabled, mfaEnabled, t]);

  return (
    <Box
      gap="space-400"
      paddingTop={{
        desktop: undefined,
        tablet: 'space-400',
        mobile: 'space-400',
      }}
      padding={{
        desktop: 'space-400',
        tablet: 'space-400',
        mobile: undefined,
      }}
    >
      <Box flexDirection="row" justifyContent="space-between">
        <Text
          variant="body-m-semi"
          locNS="account"
          locKey="mfaLabel"
          color="darkSurfacePrimary"
        />
        <Switch value={localEnabled} onValue={setLocalEnabled} />
      </Box>
      <Button
        locNS="common"
        locKey="save"
        variant="secondary"
        loading={isUpdating}
        onPress={onSave}
      />
    </Box>
  );
}

export default memo(AccountMFA);
